const { findByAddress } = require('@hints/utils/data');
const Interpretor = require('./interpretor');

module.exports = new Interpretor([
    {
        id: 'strongly-altered-sleep',
        conditions: [{ id: 'score', min: 0, max: 14, value: e => findByAddress(e, 'evalSleep.answerScore') }],
    },
    {
        id: 'altered-sleep',
        conditions: [{ id: 'score', min: 15, max: 23, value: e => findByAddress(e, 'evalSleep.answerScore') }],
    },
    {
        id: 'normal-sleep',
        conditions: [{ id: 'score', min: 24, max: 30, value: e => findByAddress(e, 'evalSleep.answerScore') }],
    }
]);